import { DialogActions, DialogTitle, Divider, IconButton } from "@mui/material"
import { CloseOutlined } from "@mui-symbols-material/w300"
import type { ReactElement, ReactNode } from "react"

import { Button } from "@/components/common/Button"

const DialogArea = ({
  title,
  onClose,
  onSubmit,
  children,
  isSubmitEnabled,
  cancelText = "Cancel",
  submitText = "Save",
}: {
  title: string
  onClose: () => void
  onSubmit: () => void
  isSubmitEnabled: boolean
  children: ReactNode
  cancelText?: string
  submitText?: string
}): ReactElement => {
  return (
    <>
      <DialogTitle className='pl-10 pr-14 text-ml font-normal text-primary'>{title}</DialogTitle>
      <IconButton aria-label='close' onClick={onClose} className='absolute right-4 top-4 text-primary'>
        <CloseOutlined />
      </IconButton>
      <Divider />
      {children}
      <DialogActions className='justify-between p-10'>
        <Button appearance='outlined' onClick={onClose}>
          {cancelText}
        </Button>
        <Button onClick={onSubmit} disabled={!isSubmitEnabled}>
          {submitText}
        </Button>
      </DialogActions>
    </>
  )
}

export default DialogArea
